/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateAddressData } from './UpdateAddressData';
import {
    UpdateAddressDataFromJSON,
    UpdateAddressDataFromJSONTyped,
    UpdateAddressDataToJSON,
    UpdateAddressDataToJSONTyped,
} from './UpdateAddressData';

/**
 * 
 * @export
 * @interface UpdateCompanyData
 */
export interface UpdateCompanyData {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyData
     */
    name?: string;
    /**
     * 
     * @type {UpdateAddressData}
     * @memberof UpdateCompanyData
     */
    address?: UpdateAddressData;
    /**
     * The locales a company can be set to, which drive both translations and the formatting of dates and numbers.
     * @type {string}
     * @memberof UpdateCompanyData
     */
    locale?: UpdateCompanyDataLocaleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyData
     */
    timezone?: string;
    /**
     * A series of national/public holidays that apply to this company
     * @type {number}
     * @memberof UpdateCompanyData
     */
    holidayRegionId?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum UpdateCompanyDataLocaleEnum {
    EnGb = 'en-GB',
    EnUs = 'en-US',
    FrFr = 'fr-FR'
}


/**
 * Check if a given object implements the UpdateCompanyData interface.
 */
export function instanceOfUpdateCompanyData(value: object): value is UpdateCompanyData {
    return true;
}

export function UpdateCompanyDataFromJSON(json: any): UpdateCompanyData {
    return UpdateCompanyDataFromJSONTyped(json, false);
}

export function UpdateCompanyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : UpdateAddressDataFromJSON(json['address']),
        'locale': json['locale'] == null ? undefined : json['locale'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'holidayRegionId': json['holidayRegionId'] == null ? undefined : json['holidayRegionId'],
    };
}

  export function UpdateCompanyDataToJSON(json: any): UpdateCompanyData {
      return UpdateCompanyDataToJSONTyped(json, false);
  }

  export function UpdateCompanyDataToJSONTyped(value?: UpdateCompanyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': UpdateAddressDataToJSON(value['address']),
        'locale': value['locale'],
        'timezone': value['timezone'],
        'holidayRegionId': value['holidayRegionId'],
    };
}

